import React, { useEffect } from "react";
// import SearchBar from "../../../../utils/SearchBar";
import Style from "./Search.module.scss";
import Icon from "../../../Layouts/Icons";
import useProjects from "../../../../Logic/useProjects";
import { useSearch } from "../../../../Logic/FilterHeaders/ProjectHeader/useSearch";
import { useRef } from "react";
import { handleCustomSearchText } from "../../../../store/slices/Project/ProjectSlice";
import { useDispatch } from "react-redux";

export const Search = ({
  windowDimensions,
  setIsMobileSearch,
  isMobileSearch,
  handleChange,
  text,
  setResetVisible,
  setTextContent,
}) => {
  const {
    isFocused,
    setIsFocused,
    resetVisible,
    // handleClear,
    handleResetVisible,
  } = useProjects();
  const { handleChangeInput, searchText, handleClear } = useSearch();
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const handleClearInput = () => {
    dispatch(handleCustomSearchText(""));
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    handleClear();
  };
  useEffect(() => {}, [isFocused]);
  return (
    <>
      {windowDimensions.width < 1200 && (
        <>
          <button
            className={`btn btn-link ${Style.ContentHeader_mob_Search_btn}`}
            onClick={() => setIsMobileSearch(true)}
          >
            <Icon size={18} icon={"icon-search"} />
          </button>
        </>
      )}
      {(isMobileSearch && windowDimensions.width < 1200) ||
      windowDimensions.width >= 1200 ? (
        <>
          <div className={Style.ContentHeader_searchbar_wrap}>
            <div
              //   action={"#"}
              className={`${Style.SearchBar} ${
                isFocused ? Style.focused : ""
              } ${resetVisible ? Style.hasValue : ""}`}
            >
              <div className={Style.SearchBar__searchIcon}>
                <Icon size={18} icon={"icon-search"} />
              </div>
              <input
                ref={inputRef}
                value={text ? text : ""}
                type="text"
                name="search"
                placeholder="Search here"
                className={Style.SearchBar__searchInput}
                autoComplete="new-password"
                onFocus={() => {
                  if (typeof setIsFocused === "function") {
                    setIsFocused(true);
                  }
                }}
                onBlur={() => {
                  if (typeof setIsFocused === "function") {
                    setIsFocused(true);
                  }
                }}
                onChange={(e) => {
                  handleChange(e);
                  if (typeof handleResetVisible === "function") {
                    handleResetVisible(e);
                  }
                }}
              />
              {text?.length >= 1 ? (
                <div
                  className={Style.SearchBar__searchReset}
                  onClick={() => {
                    handleClearInput();
                  }}
                >
                  <Icon color={""} size={14} icon={"icon-close"} />
                </div>
              ) : (
                ""
              )}
            </div>
            {windowDimensions.width < 1200 && (
              <>
                <button
                  className="btn btn-link"
                  onClick={() => setIsMobileSearch(false)}
                >
                  Cancel
                </button>
              </>
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
